var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{directives:[{name:"authenticated-image",rawName:"v-authenticated-image",value:(_vm.getLastReviewImageFile(_vm.customerDetails)),expression:"getLastReviewImageFile(customerDetails)"}],staticClass:"image-preview"})])}
var staticRenderFns = []

export { render, staticRenderFns }